import { firestore } from '../contexts/FirebaseContext';
import { v1 as uuidv1 } from 'uuid';

export async function createNotification(title, description, avatar, type, userid, link) {
  const notification = { title, description, avatar, type, userid, createdAt: new Date(), isUnRead: true, link };
  await firestore.collection('notifications').doc(uuidv1()).set(notification);
}

export async function markAsReadNotification(idNotification) {
  await firestore.collection('notifications').doc(idNotification).update({ isUnRead: false });
}

export async function markAsReadNotifications(userid) {
  await firestore
    .collection('notifications')
    .where('userid', '==', userid)
    .get()
    .then((queryS) => {
      queryS.forEach((doc) => {
        firestore.collection('notifications').doc(doc.id).update({ isUnRead: false });
      });
    });
}

export async function createNotificationsByRole(role, title, description, avatar, type, link) {
  const docs = await (
    await firestore.collection('users').where('role', '==', role).get()
  ).docs.map((doc) => ({ id: doc.id, ...doc.data() }));

  docs.forEach((doc) => {
    createNotification(title, description, avatar, type, doc.id, link);
  });
}
